import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { SiteLevelDomainsResultsPage } from './ResultsPage';
import { SiteLevelGateHomePage } from './HomePage';
import { GatePath } from '../types';
export { GatePath };
export const SiteSearchGatePages = _ref => {
  let {
    handlers,
    externalViewer
  } = _ref;
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.ModalsProvider, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: GatePath.RESULTS,
    render: () => /*#__PURE__*/React.createElement(SiteLevelDomainsResultsPage, {
      handlers: handlers,
      externalViewer: externalViewer
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: GatePath.GATE,
    render: () => /*#__PURE__*/React.createElement(SiteLevelGateHomePage, {
      handlers: handlers,
      externalViewer: externalViewer
    })
  })));
};
//# sourceMappingURL=SiteSearchGate.js.map